import GetFoldersRequestModelBase from '../_generated/modelBases/get-folders-request-model-base';

export default class GetFoldersRequestModel extends GetFoldersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
